
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getCreateMeetingDecisionDtoFormGroup() {
return new FormGroup({
    meetingId: new FormControl<number | undefined>(undefined, [Validators.required]),
    description: new FormControl<string | undefined>('', [Validators.required]),
    decidedAt: new FormControl<string | undefined>(''),
})
;
}
      